import type { ThemeDefinition } from "./types";
import { PALETTE, GPU_CLEAR_VOID, GPU_SHALLOWS, GPU_CORAL, GPU_SAPPHIRE } from "./palette";

export const abyss: ThemeDefinition = {
  label: "Abyss",
  className: "theme-abyss",
  bg: PALETTE.void,
  text: PALETTE.shallows,
  textMuted: `color-mix(in srgb, ${PALETTE.shallows} 60%, transparent)`,
  accent: PALETTE.coral,
  glassRgb: "3,8,16",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(168,204,214,0.18)",
  selection: PALETTE.sapphire,
  selectionText: "#ffffff",
  gridColor: PALETTE.shallows,
  noiseOpacity: "0.06",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.45)",
  gpuClear: GPU_CLEAR_VOID,
  gpuGridLine: GPU_SHALLOWS,
  gpuGridAlpha: 0.7,
  gpuAxisX: GPU_CORAL,
  gpuAxisZ: GPU_SAPPHIRE,
  axisXColor: PALETTE.coral,
  axisZColor: PALETTE.sapphire,
  font: '"Space Grotesk", sans-serif',
};
